import { createApp } from 'vue'
import Translations from './i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import dayjs from 'dayjs';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Unicon from 'vue-unicons';
import './assets/Styles/main.scss';
import { uniFilesLandscapesAlt, uniUsersAlt, uniEditAlt, uniSave, uniTrashAlt, uniSearch, uniFileCopyAlt, uniSignout, uniUserCheck, uniUserTimes, uniAngleRight, uniAngleLeft, uniSpinnerAlt } from 'vue-unicons/dist/icons'

Unicon.add([uniFilesLandscapesAlt, uniUsersAlt, uniEditAlt, uniSave, uniTrashAlt, uniSearch, uniFileCopyAlt, uniSignout, uniUserCheck, uniUserTimes, uniAngleRight ,uniAngleLeft, uniSpinnerAlt])

export const app = createApp(App)
const ApiURL = process.env.VUE_APP_API_URL;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$ApiURL = ApiURL;
app.config.globalProperties.$dayjs = dayjs

app.use(Translations)
app.use(router)
app.use(store)
app.use(VueSweetalert2)
app.use(Unicon)

app.mount('#app')
